import { MarkdownToJSX } from 'markdown-to-jsx'

import { customComponents } from './consts/customComponents'
import { htmlComponents } from './consts/htmlComponents'

export type MarkdownConfigurationInput = {
  isHtmlOnly?: boolean
  isLiveContent?: boolean
  isReference?: boolean
  messageId?: string
}

export const configuration = ({ isHtmlOnly, isLiveContent, isReference, messageId }: MarkdownConfigurationInput) =>
  ({
    overrides: {
      ...htmlComponents({ isLiveContent, isReference, messageId }),
      ...(isHtmlOnly ? {} : customComponents({ isLiveContent, messageId })),
    },
  } satisfies MarkdownToJSX.Options)
